import { render, staticRenderFns } from "./ButtonWithConfirm.vue?vue&type=template&id=144f5234"
import script from "./ButtonWithConfirm.vue?vue&type=script&lang=ts"
export * from "./ButtonWithConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports